
export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/supplier-types`,
        name: `${prefix}.supplier-types.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.supplier-types.index`,
                PageDescription: "Supplier Configurations: Supplier types",
            },
        },
    },
];
